import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'app/service/auth/auth.service';
import { ToastrService } from 'ngx-toastr';
import emailMask from 'text-mask-addons/dist/emailMask';

@Component({
    selector: 'app-signin',
    templateUrl: './signin.component.html',
    styleUrls: ['./signin.component.scss']
})
export class SigninComponent implements OnInit {

    signinForm: FormGroup;
    emailMaskHtml = emailMask;

    constructor(
        public fb: FormBuilder,
        public authService: AuthService,
        public router: Router,
        private toastr: ToastrService
    ) { }

    ngOnInit() {
        this.signinForm = this.fb.group({
            emailSignin: ['', [Validators.required, Validators.email]],
            passwordSignin: ['', [Validators.required]],
        });
    } // fin ngOnInit

    loginUser() {
        this.authService.signIn(this.signinForm.value).subscribe((response: any) => {
            if (response.message === 'Adresse email ou mot de passe invalide.') {
                this.toastr.warning('Adresse email ou mot de passe invalide.');
            } else {
                this.toastr.success('Vous êtes connecté');
                localStorage.setItem('access_token', JSON.stringify(response));
                this.authService.userSubject.next(response);
                this.router.navigate(['home']);
                const dataSend = {
                    type: 'userLogged',
                    response: response.token
                };
                this.authService.injectonSubject(dataSend);
            }
        });
    } // fin loginUser

}
